import Eu from '@di-shared/features/history/date/HistoryDate/.eu';
import Kr from '@di-shared/features/history/date/HistoryDate/.kr';
import Environment from '@di-shared/features/environment/Environment';

export interface HistoryDateProps {
  vin: string;
  date: Date;
}

export default function HistoryDate({vin, date}: HistoryDateProps) {
  return (
    <>
      <Environment.Eu>
        <Eu
          vin={vin}
          date={date}
        />
      </Environment.Eu>
      <Environment.Kr>
        <Kr
          vin={vin}
          date={date}
        />
      </Environment.Kr>
    </>
  );
}
